import React, { useState } from 'react';
import './Contact.css';
import { db } from '../../../services/firebase/firebaseconfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import Footer from '../../../components/layout/Footer/Footer';
import Header from '../../../components/layout/Header/Header';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    type: 'general'
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(collection(db, 'contactMessages'), {
        ...formData,
        createdAt: serverTimestamp(),
        status: 'new',
        read: false
      });

      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        type: 'general'
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="classjustforheadercolor"></div>

      <Header />

      {/* Hero Split Section */}
      <section className="contact-hero">
        {/* Left Side - Content */}
        <div className="contact-hero__left">
          <div className="hero-content">
            <div className="hero-badge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
              <span>Support 24/7</span>
            </div>

            <h1 className="contact-hero__title">
              Parlons de Votre <span className="title-highlight">Projet</span>
            </h1>

            <p className="contact-hero__subtitle">
              Notre équipe d'experts est prête à transformer votre espace de travail
              avec des solutions sur mesure et un service d'excellence.
            </p>

            {/* Contact Methods */}
            <div className="contact-methods">
              <div className="contact-method">
                <div className="contact-method__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </div>
                <div className="contact-method__content">
                  <h4>Téléphone</h4>
                  <p>+213 560 60 56 55</p>
                  <p>+213 560 39 42 54</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-method__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </div>
                <div className="contact-method__content">
                  <h4>Email</h4>
                  <p>contact@burotime.dz</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-method__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div className="contact-method__content">
                  <h4>Adresse</h4>
                  <p>Alger Centre, Algiers</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-method__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </div>
                <div className="contact-method__content">
                  <h4>Horaires</h4>
                  <p>Lun-Sam: 8h-18h</p>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-item__number">15+</div>
                <div className="stat-item__label">Années d'expérience</div>
              </div>
              <div className="stat-item">
                <div className="stat-item__number">2.5k+</div>
                <div className="stat-item__label">Clients satisfaits</div>
              </div>
              <div className="stat-item">
                <div className="stat-item__number">24/7</div>
                <div className="stat-item__label">Support disponible</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="contact-hero__right">
          <div className="form-container">
            {submitted ? (
              <div className="success-message">
                <div className="success-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                </div>
                <h3 className="success-message__title">Message Envoyé!</h3>
                <p className="success-message__text">
                  Merci de nous avoir contactés. Notre équipe vous répondra dans les 24 heures.
                </p>
                <button
                  className="btn-secondary"
                  onClick={() => setSubmitted(false)}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M19 12H5M12 19l-7-7 7-7" />
                  </svg>
                  Envoyer un autre message
                </button>
              </div>
            ) : (
              <>
                <div className="form-header">
                  <h2 className="form-header__title">Envoyez-nous un Message</h2>
                  <p className="form-header__subtitle">
                    Remplissez le formulaire et nous vous contacterons rapidement
                  </p>
                </div>

                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Nom Complet</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      placeholder="Jean Dupont"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Adresse Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="jean.dupont@email.com"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Téléphone</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="+213 XXX XX XX XX"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="type">Type de Demande</label>
                    <select
                      id="type"
                      name="type"
                      value={formData.type}
                      onChange={handleInputChange}
                    >
                      <option value="general">Question Générale</option>
                      <option value="product">Information Produit</option>
                      <option value="quote">Demande de Devis</option>
                      <option value="technical">Support Technique</option>
                      <option value="partnership">Partenariat</option>
                      <option value="complaint">Réclamation</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Sujet</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                      placeholder="Sujet de votre message"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Votre Message</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      placeholder="Décrivez votre demande en détail..."
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="btn-submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <div className="spinner"></div>
                        Envoi en cours...
                      </>
                    ) : (
                      <>
                        Envoyer le Message
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </>
                    )}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="contact-info-section">
        <div className="container">
          <div className="section-header">
            <span className="section-header__badge">Informations Pratiques</span>
            <h2 className="section-header__title">Pourquoi Nous Choisir?</h2>
            <p className="section-header__subtitle">
              Nous offrons bien plus qu'un simple service. Découvrez ce qui fait de nous
              votre partenaire idéal pour l'aménagement de bureau.
            </p>
          </div>

          <div className="info-grid">
            <div className="info-card">
              <div className="info-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>
              <h3 className="info-card__title">Garantie Qualité</h3>
              <div className="info-card__content">
                <p>Tous nos produits sont garantis 5 ans</p>
                <p>Certification ISO 9001</p>
                <p>Matériaux premium</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="8.5" cy="7" r="4" />
                  <polyline points="17 11 19 13 23 9" />
                </svg>
              </div>
              <h3 className="info-card__title">Service Personnalisé</h3>
              <div className="info-card__content">
                <p>Consultation gratuite</p>
                <p>Design sur mesure</p>
                <p>Accompagnement complet</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                  <line x1="1" y1="10" x2="23" y2="10" />
                </svg>
              </div>
              <h3 className="info-card__title">Paiement Flexible</h3>
              <div className="info-card__content">
                <p>Plusieurs modes de paiement</p>
                <p>Paiement en plusieurs fois</p>
                <p>Devis transparent</p>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="map-wrapper">
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3194.215276347803!2d3.039376315294803!3d36.75250897996248!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDQ1JzA5LjAiTiAzwrAwMiczMS4xIkU!5e0!3m2!1sen!2sdz!4v1"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="BuroTime Showroom Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Hours Section */}
      <section className="hours-section">
        <div className="container">
          <div className="hours-container">
            <div className="hours-card">
              <h2 className="hours-card__title">Heures d'Ouverture</h2>
              <div className="hours-list">
                <div className="hours-item">
                  <span className="hours-item__day">Dimanche-Jeudi</span>
                  <span className="hours-item__time hours-item__time--open">8h00 - 18h00</span>
                </div>
                <div className="hours-item">
                  <span className="hours-item__day">Samedi</span>
                  <span className="hours-item__time hours-item__time--open">9h00 - 17h00</span>
                </div>
                <div className="hours-item">
                  <span className="hours-item__day">Vendredi</span>
                  <span className="hours-item__time hours-item__time--closed">Fermé</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;